import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 20.25h9m-3-3.002h6a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 6v8.998a2.25 2.25 0 002.25 2.25h5a2.25 2.25 0 012.25 2.25v.75m3.077-10.18l-4.327-2.5a.5.5 0 00-.75.433V13a.5.5 0 00.75.433l4.327-2.499a.5.5 0 000-.866z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 20.25h9m-3-3.002h6a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 6v8.998a2.25 2.25 0 002.25 2.25h5a2.25 2.25 0 012.25 2.25v.75m3.077-10.18l-4.327-2.5a.5.5 0 00-.75.433V13a.5.5 0 00.75.433l4.327-2.499a.5.5 0 000-.866z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 40.5h18m-6-6.004h12a4.5 4.5 0 004.5-4.5V12c0-2.484-2.016-4.5-4.5-4.5H9A4.502 4.502 0 004.5 12v17.996a4.5 4.5 0 004.5 4.5h10c2.484 0 4.5 2.016 4.5 4.5v1.5m6.154-20.361L21 15.139a1 1 0 00-1.5.866v9.994a1 1 0 001.5.866l8.654-4.998a.999.999 0 000-1.732z"
  }))
};
export var ClassWorkout = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});